import { createContext, useContext } from "react";
import type { AppState } from "./types";

export const Ctx = createContext<AppState | null>(null);

export function useApp() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useApp requires AppProvider");
  return v;
}
